import { addZero } from '../../utils/stringUtil';
import { FormCard, FormGroup, LocationRow, LocationBlock, SwapBtn, TimeRow } from './PlanMain.styles';

const hourOptions = () => {
    let result = [<option key={-1} value="">시</option>];
    for (let i = 0; i < 24; i++) {
        result.push(<option key={i} value={addZero(i)}>{i}시</option>);
    }
    return result;
};

const minuteOptions = () => {
    let result = [<option key={-1} value="">분</option>];
    for (let i = 0; i < 12; i++) {
        result.push(<option key={i * 5} value={addZero(i * 5)}>{i * 5}분</option>);
    }
    return result;
};

const PlanForm = ({ form, setField, onOpenMap, onChangeTarget }) => {
    return (
        <FormCard>
            <FormGroup>
                <label>제목</label>
                <input
                    type="text"
                    placeholder="일정 이름을 입력하세요"
                    onChange={(e) => setField('titleTxt', e.target.value)}
                    value={form.titleTxt}
                />
            </FormGroup>

            <LocationRow>
                <LocationBlock>
                    <label>출발</label>
                    <input
                        type="text"
                        placeholder="출발지 선택"
                        onClick={() => onOpenMap("start")}
                        value={form.startLb ? form.startLb.split(" ").slice(-1)[0] : ""}
                        readOnly
                    />
                    <TimeRow>
                        <select onChange={(e) => setField('startHour', e.target.value)} value={form.startHour}>
                            {hourOptions()}
                        </select>
                        <select onChange={(e) => setField('startMinute', e.target.value)} value={form.startMinute}>
                            {minuteOptions()}
                        </select>
                    </TimeRow>
                </LocationBlock>

                <SwapBtn onClick={onChangeTarget}>⇄</SwapBtn>

                <LocationBlock>
                    <label>도착</label>
                    <input
                        type="text"
                        placeholder="도착지 선택"
                        onClick={() => onOpenMap("dest")}
                        value={form.destLb ? form.destLb.split(" ").slice(-1)[0] : ""}
                        readOnly
                    />
                    <TimeRow>
                        <select onChange={(e) => setField('destHour', e.target.value)} value={form.destHour}>
                            {hourOptions()}
                        </select>
                        <select onChange={(e) => setField('destMinute', e.target.value)} value={form.destMinute}>
                            {minuteOptions()}
                        </select>
                    </TimeRow>
                </LocationBlock>
            </LocationRow>
        </FormCard>
    );
};

export default PlanForm;
